import React from "react";
import { Link } from "react-router-dom";
import { OUTBOUND_URL, characters } from "../data/characters";

const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-black text-white pt-20 pb-10"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-12">
        {/* Massive brand */}
        <div
          data-testid="footer-brand"
          className="font-display font-black tracking-tighter uppercase text-[14vw] leading-[0.85] border-b-2 border-white/20 pb-8"
        >
          Character<span className="text-[#00E5FF]">.</span>AI<span className="text-[#FF2D55]">.</span>Chat
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <p className="font-body text-white/70 max-w-md leading-relaxed">
              CharacterAIChat is a fast, immersive way to chat with AI
              characters online. Cozy companions, fantasy partners, anime
              characters, romantic AI girls and original personalities —
              every conversation is built for memory, roleplay and instant
              replies.
            </p>
            <a
              data-testid="footer-cta"
              href={OUTBOUND_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="brutal-shadow-light mt-8 inline-flex items-center gap-3 bg-[#00E5FF] text-black font-display font-black uppercase tracking-tight text-base px-6 py-3 border-2 border-white"
            >
              Start Character AI Chat →
            </a>
          </div>

          <nav aria-label="Characters">
            <h4 className="font-display text-sm font-bold tracking-[0.25em] uppercase text-white/50">
              Characters
            </h4>
            <ul className="mt-4 space-y-2">
              {characters.map((c) => (
                <li key={c.id}>
                  <Link
                    data-testid={`footer-char-link-${c.id}`}
                    to={`/${c.id}`}
                    className="font-body text-white/90 hover:text-[#00E5FF] transition"
                  >
                    {c.name} — {c.archetype}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="Sitemap">
            <h4 className="font-display text-sm font-bold tracking-[0.25em] uppercase text-white/50">
              Sitemap
            </h4>
            <ul className="mt-4 space-y-2">
              <li>
                <a
                  href="/#characters"
                  className="font-body text-white/90 hover:text-[#FF2D55] transition"
                  data-testid="footer-link-characters"
                >
                  AI Characters
                </a>
              </li>
              <li>
                <a
                  href="/#features"
                  className="font-body text-white/90 hover:text-[#FF2D55] transition"
                  data-testid="footer-link-features"
                >
                  Why Choose Us
                </a>
              </li>
              <li>
                <a
                  href="/#how-it-works"
                  className="font-body text-white/90 hover:text-[#FF2D55] transition"
                  data-testid="footer-link-how"
                >
                  How It Works
                </a>
              </li>
              <li>
                <a
                  href="/#faq"
                  className="font-body text-white/90 hover:text-[#FF2D55] transition"
                  data-testid="footer-link-faq"
                >
                  FAQ
                </a>
              </li>
              <li>
                <a
                  href="/sitemap.xml"
                  className="font-body text-white/90 hover:text-[#FF2D55] transition"
                  data-testid="footer-link-sitemap"
                >
                  XML Sitemap
                </a>
              </li>
            </ul>
          </nav>
        </div>

        <div className="mt-16 pt-8 border-t border-white/20 flex flex-col sm:flex-row gap-4 justify-between items-start sm:items-center text-sm font-body text-white/60">
          <p>
            © {new Date().getFullYear()} CharacterAIChat. All rights reserved.
          </p>
          <p className="uppercase tracking-[0.2em] font-bold text-xs">
            characteraichat.org
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
